import { ACTION_SUBJECT_PREFIX, EVENT_SOURCE } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

type ThirdPartyQuerySuggestionClickedArgs = {
	productKey: string;
	suggestionType: 'static' | 'dynamic';
	suggestion: string;
};

export const onThirdPartyQuerySuggestionClicked = ({
	suggestionType,
	suggestion,
	productKey,
}: ThirdPartyQuerySuggestionClickedArgs): FireAnalyticsEvent => ({
	source: EVENT_SOURCE,
	eventType: 'ui',
	actionSubject: `${ACTION_SUBJECT_PREFIX}ThirdPartyQuerySuggestion`,
	action: 'clicked',
	attributes: {
		additionalAttributes: {
			productKey,
			suggestionType,
			suggestion,
		},
	},
});
